import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-load_ship_task",
  "use": "icon-load_ship_task-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-load_ship_task\"><path d=\"M640 704h64v64h-64z\" p-id=\"2172\" fill=\"#ffffff\" /><path d=\"M128 512l64 384h576l128-384H128z m593.9 320H246.2l-42.7-256h603.7l-85.3 256zM256 384h512v64H256zM256 256h512v64H256zM256 128h512v64H256z\" p-id=\"2173\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/load_ship_task.svg
// module id = fq31
// module chunks = 39